import React from 'react';
import CopyToClipboard from './utils/CopyToClipboard';
import Prism from 'prismjs';
import LinkableTitle from './linkableTitle';

const Version = ({ version, name }) => (
  <div className="package-version">
    <LinkableTitle name="package-version" title="Package version" />
    <div className="copy-snippet">
      <i className="icon icon-node" />
      <CopyToClipboard className="clipboard-code" clipboardText={name}>
        <pre dangerouslySetInnerHTML={{ __html: Prism.highlight(name, Prism.languages.javascript, 'javascript') }} />
      </CopyToClipboard>
      <CopyToClipboard className="clipboard-code clipboard-code-version" clipboardText={version}>
        <pre dangerouslySetInnerHTML={{ __html: Prism.highlight(version, Prism.languages.javascript, 'javascript') }} />
      </CopyToClipboard>
    </div>
  </div>
);

Version.displayName = 'Version';

export default Version;
